import * as React from 'react'

import { cn } from '../lib/cn'
import type { IconComponent } from '../lib/icons'

export interface EmptyStateProps {
  /** The translated heading: what is missing. */
  title: string
  /** Supporting text: why it is empty, or what to do about it. Optional. */
  description?: string
  /** Decorative icon; rendered `aria-hidden` because the title already says it all. */
  icon?: IconComponent
  /** The action that leaves the empty state (normally a Button). Optional. */
  action?: React.ReactNode
  className?: string
}

/** The empty state of a list or a page. It receives its text, it does not hold any. */
export function EmptyState({ title, description, icon: Icon, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-border p-8 text-center',
        className,
      )}
    >
      {Icon ? <Icon className="size-8 text-muted-foreground" aria-hidden="true" /> : null}
      <div className="flex flex-col gap-1">
        <p className="text-base font-medium text-foreground">{title}</p>
        {description ? <p className="text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {action}
    </div>
  )
}
